import { call, put, takeLatest } from 'redux-saga/effects'

import { NOTIFICATION_TYPE } from '~/common/constants'
import addNotification from '~/utils/toast'

import {
  actGetListVehicleRegisterFailed,
  actGetListVehicleRegisterSuccess,
  MASTER_GET_LIST_VEHICLE_REGISTER,
} from '../../actions/vehicle-register'
import { apiGetListVehicleRegister } from '../../apis/vehicle-register'

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doGetList(action) {
  try {
    const response = yield call(apiGetListVehicleRegister, action?.payload)

    if (response?.statusCode === 200) {
      const data = {
        data: response.data.items,
        meta: response.data.meta
      }
      yield put(actGetListVehicleRegisterSuccess(data))
      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess()
      }
    } else {
      addNotification(response?.message, NOTIFICATION_TYPE.ERROR)
      throw new Error(response?.message)
    }
  } catch (error) {
    yield put(actGetListVehicleRegisterFailed())
    // Call callback action if provided
    if (action.onError) {
      yield action.onError(error)
    }
  }
}

export default function* watchGetList() {
  yield takeLatest(MASTER_GET_LIST_VEHICLE_REGISTER, doGetList)
}
